var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.options),function(option){return _c('button',{key:option.text,staticClass:"h-btn-bordered h-margin-right-s h-btn-height20",class:{
      'h-btn-fill-accent': option.enabled === true,
      'h-btn-bordered ': option.enabled === false,
      'h-btn-bordered ': option.enabled === null,
    },attrs:{"title":option.hint},on:{"click":function($event){return _vm.$emit('click', option)}}},[_vm._v(" "+_vm._s(option.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }